(() => {
  if (window.LuemasShopifyFormsTriggerLoaded) return;
  window.LuemasShopifyFormsTriggerLoaded = true;

  const normalize = (value) => String(value || '')
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const isVisible = (el) => {
    if (!el || el.closest('[hidden], [aria-hidden="true"]')) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const closestSection = (trigger) => trigger.closest('.luemas-future-talent') || document;

  const openThemeModal = (trigger) => {
    const section = closestSection(trigger);
    const type = trigger.getAttribute('data-luemas-form-type');
    const modal = section.querySelector(`[data-luemas-form-modal="${type}"]`);
    if (!modal) return false;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.classList.add('luemas-form-modal-open');
    const firstField = modal.querySelector('input, textarea, select, button');
    if (firstField) setTimeout(() => firstField.focus({ preventScroll: true }), 60);
    return true;
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    if (!document.querySelector('.luemas-form-modal.is-open')) {
      document.body.classList.remove('luemas-form-modal-open');
    }
  };

  const tryAPIs = (formName) => {
    const candidates = [
      () => window.ShopifyForms && typeof window.ShopifyForms.open === 'function' && window.ShopifyForms.open(formName),
      () => window.ShopifyForms && typeof window.ShopifyForms.show === 'function' && window.ShopifyForms.show(formName),
      () => window.ShopifyForms && typeof window.ShopifyForms.trigger === 'function' && window.ShopifyForms.trigger(formName),
      () => window.Shopify && window.Shopify.Forms && typeof window.Shopify.Forms.open === 'function' && window.Shopify.Forms.open(formName),
      () => window.Shopify && window.Shopify.forms && typeof window.Shopify.forms.open === 'function' && window.Shopify.forms.open(formName)
    ];
    for (const fn of candidates) {
      try { if (fn()) return true; } catch (e) {}
    }
    try {
      document.dispatchEvent(new CustomEvent('shopify:forms:open', { detail: { name: formName, formName } }));
      document.dispatchEvent(new CustomEvent('ShopifyForms:open', { detail: { name: formName, formName } }));
    } catch (e) {}
    return false;
  };

  const clickSelector = (selector, trigger) => {
    if (!selector) return false;
    let target = null;
    try { target = document.querySelector(selector); } catch (e) { return false; }
    if (!target || target === trigger || trigger.contains(target)) return false;
    if (typeof target.click === 'function') {
      target.click();
      return true;
    }
    return false;
  };

  const findAndClickNativeLauncher = (formName, trigger) => {
    const wanted = normalize(formName);
    if (!wanted) return false;
    const selectors = [
      '[data-shopify-forms-id]', '[data-shopify-form-id]', '[data-shopify-forms-trigger]', '[data-shopify-forms-modal]',
      '[data-form-name]', '[data-form-id]', '[data-testid*="forms" i]', '[aria-label]', '[title]',
      'button', 'a', '[role="button"]', 'summary'
    ].join(',');
    const candidates = Array.from(document.querySelectorAll(selectors));
    for (const el of candidates) {
      if (el === trigger || trigger.contains(el) || el.closest('.luemas-future-talent') === trigger.closest('.luemas-future-talent')) continue;
      const haystack = normalize([
        el.getAttribute('data-form-name'),
        el.getAttribute('data-shopify-forms-id'),
        el.getAttribute('data-shopify-form-id'),
        el.getAttribute('data-form-id'),
        el.getAttribute('aria-label'),
        el.getAttribute('title'),
        el.textContent
      ].filter(Boolean).join(' '));
      if (haystack && (haystack.includes(wanted) || wanted.includes(haystack))) {
        try { el.click(); return true; } catch (e) {}
      }
    }
    return false;
  };

  const openNativeOrFallback = (trigger) => {
    const formName = trigger.getAttribute('data-luemas-form-name') || '';
    const selector = trigger.getAttribute('data-luemas-form-selector') || '';
    const useFallback = trigger.getAttribute('data-luemas-fallback') === 'true';

    if (clickSelector(selector, trigger)) return;
    if (tryAPIs(formName)) return;

    // Give app embeds a short moment to respond to the custom event before fallback.
    window.setTimeout(() => {
      if (findAndClickNativeLauncher(formName, trigger)) return;
      if (useFallback) {
        openThemeModal(trigger);
      } else {
        const href = trigger.getAttribute('href');
        if (href && href !== '#') window.location.href = href;
      }
    }, 160);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-luemas-form-trigger]');
    if (!trigger) return;
    event.preventDefault();
    openNativeOrFallback(trigger);
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-luemas-form-close]');
    if (closeButton) {
      closeModal(closeButton.closest('.luemas-form-modal'));
      return;
    }
    const modal = event.target.classList && event.target.classList.contains('luemas-form-modal') ? event.target : null;
    if (modal) closeModal(modal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.luemas-form-modal.is-open').forEach(closeModal);
  });
})();
